/** One line of an `NxCheckboxMatrix` — a person, a role, a record. */
export interface NxCheckboxMatrixRow {
  key: string;
  label: string;
  /** A second, muted line under the label (an address, a kind). */
  description?: string;
  /** Every checkbox of the row is read-only. */
  disabled?: boolean;
}

/** One checkbox column. Its key is unique across all groups of the matrix. */
export interface NxCheckboxMatrixColumn {
  key: string;
  label: string;
}

/** Columns under one shared header („Ordner“ over anzeigen · anlegen · …). */
export interface NxCheckboxMatrixGroup {
  key: string;
  label: string;
  columns: readonly NxCheckboxMatrixColumn[];
}

/** The ticked cells: row key → column key → ticked. Missing cells are unticked. */
export type NxCheckboxMatrixValue = Readonly<Record<string, Readonly<Record<string, boolean>>>>;

/** The one cell a click or Space changed. */
export interface NxCheckboxMatrixChange {
  row: string;
  group: string;
  column: string;
  value: boolean;
}

/** Whether a cell is ticked. */
export function isMatrixCellChecked(
  value: NxCheckboxMatrixValue,
  row: string,
  column: string
): boolean {
  return value[row]?.[column] === true;
}

/** A new value with one cell set; the given value stays untouched. */
export function setMatrixCell(
  value: NxCheckboxMatrixValue,
  row: string,
  column: string,
  checked: boolean
): Record<string, Record<string, boolean>> {
  return { ...value, [row]: { ...value[row], [column]: checked } };
}
